import { ShiftApp } from "./ShiftApp";

export function App() {
  return <ShiftApp />;
}
